import React from "react";
import { TabPane } from "reactstrap";
import { useQuery } from "@apollo/client";
import { SERVICE_CONTENT } from "../../queries";
import animetionLogo from "../../assets/utils/images/animetion_logo.gif";

/**
 * サービスについての内容コンポーネント
 *
 * @param data サービスについての中項目とコンテンツを含むクエリ
 * @returns Component of Abour service's content
 */

interface ServiCeContent {
  data: any;
  id: string;
  index: string;
}

const Content = (data: any, id: string, index: any) => {
  const {
    loading,
    error,
    data: aa,
  } = useQuery(SERVICE_CONTENT, {
    variables: { aboutServiceItem: data.id },
  });
  if (loading) {
    return (
      <div className="loading__wrapper">
        <img
          style={{ width: "80px", margin: "auto" }}
          src={animetionLogo}
        ></img>
      </div>
    );
  }
  if (error) {
    return "#####";
  }
  const { aboutServiceContent } = aa;

  return (
    <TabPane tabId={data.index.toString()}>
      <h4>
        {data.data.node.title}
        <br />
      </h4>
      <div className="divider" />
      {aboutServiceContent.edges.map((array: any, index: number) => (
        <>
          <div className="policyContents">
            <p>
              <span className="title">{array.node.title}</span>
              <div dangerouslySetInnerHTML={{ __html: array.node.text }}></div>
              <br />
            </p>
          </div>
        </>
      ))}
    </TabPane>
  );
};

export default Content;
